import {
  MdCheckCircle,
  MdDeleteForever,
  MdDoNotTouch,
  MdInventory2,
  MdLocalShipping,
  MdNewReleases,
  MdShower,
} from 'react-icons/md';
import { IoIosUndo } from 'react-icons/io';

const statusToShowSettings = [
  {
    statusID: 0, // NEW
    color: '#41C7A7',
    bg: '#41C7A730',
    Icon: MdCheckCircle,
  },
  {
    statusID: 4, //   WASHED,
    color: '#3A2EC7',
    bg: '#3A2EC730',
    Icon: MdShower,
  },
  {
    statusID: 1, // PACKED
    color: '#BB8553',
    bg: '#BB855330',
    Icon: MdInventory2,
  },
  {
    statusID: 2, // DELIVERED
    color: '#965AB1',
    bg: '#965AB130',
    Icon: MdLocalShipping,
  },
  // {
  //   statusID: 9, // LOST
  //   color: '#F8894B',
  //   bg: '#F8894B30',
  //   Icon: MdUnarchive,
  // },
  {
    statusID: 6, // UNUSED
    color: '#41C7A7',
    bg: '#41C7A730',
    Icon: MdDoNotTouch,
  },
  {
    statusID: 10, // DECOMMISSIONED
    color: '#DE4444',
    bg: '#DE444430',
    Icon: MdDeleteForever,
  },
];

export const altFilters = [
  {
    statusID: 0, // NEW
    color: '#41C7A7',
    bg: '#41C7A730',
    Icon: MdCheckCircle,
  },
  {
    statusID: 12, // END
    color: '#DE4444',
    bg: '#DE444430',
    Icon: MdNewReleases,
  },
];

export const ordersFilters = [
  {
    statusID: 0, // TODAY
    color: '#41C7A7',
    bg: '#41C7A730',
    Icon: MdCheckCircle,
  },
  {
    statusID: 1, // TOMORROW
    color: '#965AB1',
    bg: '#965AB130',
    Icon: MdNewReleases,
  },
  {
    statusID: 2, // OVERDUE
    color: '#DE4444',
    bg: '#DE444430',
    Icon: MdNewReleases,
  },
  {
    statusID: 3, // FUTURE
    color: '#eb349b',
    bg: '#eb349b30',
    Icon: MdNewReleases,
  },
];

export const casesFitlers = [
  {
    statusID: 0, // NEW
    color: '#41C7A7',
    bg: '#41C7A730',
    Icon: MdCheckCircle,
  },
  {
    statusID: 1, // PACKED
    color: '#BB8553',
    bg: '#BB855330',
    Icon: MdInventory2,
  },
  {
    statusID: 2, // DELIVERED
    color: '#965AB1',
    bg: '#965AB130',
    Icon: MdLocalShipping,
  },
  {
    statusID: 3, // RETURNED
    color: '#eb349b',
    bg: '#eb349b30',
    Icon: IoIosUndo,
  },
];

/** Equipment is either at its hub or delivered to a site (ClickUp 86bbmcwp3). */
export const equipmentFilters = [
  {
    statusID: 0, // NEW
    color: '#41C7A7',
    bg: '#41C7A730',
    Icon: MdCheckCircle,
  },
  {
    statusID: 2, // DELIVERED
    color: '#965AB1',
    bg: '#965AB130',
    Icon: MdLocalShipping,
  },
];

export const packagesFilters = [
  {
    statusID: 1, // PACKED
    color: '#BB8553',
    bg: '#BB855330',
    Icon: MdInventory2,
  },
  {
    statusID: 2, // DELIVERED
    color: '#965AB1',
    bg: '#965AB130',
    Icon: MdLocalShipping,
  },
  {
    statusID: 3, // RETURNED
    color: '#eb349b',
    bg: '#eb349b30',
    Icon: IoIosUndo,
  },
];

export const scansFilters = [
  {
    statusID: 4, //   WASHED,
    color: '#3A2EC7',
    bg: '#3A2EC730',
    Icon: MdShower,
  },
  {
    statusID: 1, // PACKED
    color: '#BB8553',
    bg: '#BB855330',
    Icon: MdInventory2,
  },
  {
    statusID: 2, // DELIVERED
    color: '#965AB1',
    bg: '#965AB130',
    Icon: MdLocalShipping,
  },
  // {
  //   statusID: 9, // LOST
  //   color: '#F8894B',
  //   bg: '#F8894B30',
  //   Icon: MdUnarchive,
  // },
  {
    statusID: 6, // UNUSED
    color: '#41C7A7',
    bg: '#41C7A730',
    Icon: MdDoNotTouch,
  },
  {
    statusID: 10, // DECOMMISSIONED
    color: '#DE4444',
    bg: '#DE444430',
    Icon: MdDeleteForever,
  },
  {
    statusID: 3, // RETURNED
    color: '#eb349b',
    bg: '#eb349b30',
    Icon: IoIosUndo,
  },
];

export default statusToShowSettings;
